var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, Icon, Box, Flex } from 'shared/components';
import { NavLink } from 'react-router-dom';
import { ChevronRight } from 'shared/assets/icons';
// Component for notes that adds hover effect to note link
var TableCellLink = function (_a) {
    var children = _a.children, to = _a.to, subtitle = _a.subtitle, disabled = _a.disabled, navLinkProps = __rest(_a, ["children", "to", "subtitle", "disabled"]);
    return (_jsxs(Box, __assign({ as: disabled ? Box : NavLink, to: to }, navLinkProps, { children: [typeof children !== 'string' && (_jsxs(Flex, __assign({ role: 'group', align: "center" }, { children: [' ', children, ' ', _jsx(Icon, { as: ChevronRight, boxSize: 3, color: "gray.400", ml: 2, transition: "200ms linear transform, 200ms linear color", _groupHover: { transform: 'translateX(4px)', color: 'green.500' } })] }))), typeof children === 'string' && (_jsxs(Text, __assign({ display: "inline-flex", alignItems: "center", transition: "200ms linear color", role: "group", _hover: disabled
                    ? {}
                    : {
                        color: 'green.500',
                    } }, { children: [children, !disabled && (_jsx(Icon, { as: ChevronRight, boxSize: 3, color: "gray.400", ml: 2, transition: "200ms linear transform, 200ms linear color", _groupHover: { transform: 'translateX(4px)', color: 'green.500' } }))] }))), subtitle && (_jsx(Text, __assign({ size: "small", mt: 2 }, { children: subtitle })))] })));
};
export { TableCellLink };
